import { TeamMember } from '@shared';

/**
 * To add a new shared resource:
 * - add to SharedResourcesType, make sure that the string value is the correct path of backend service
 *  the pattern is ${sharedResourceType}/${sharedResourceId}/team-members
 * - use sharedResourcesStore to keep track of a currently selected shared resource
 * - store current id and resourceType when resource is selected, before loading team members from backend
 * */
export enum SharedResourcesType {
  talentPool = 'talent-pools',
  job = 'job-description',
  note = 'notes',
}
export enum AccessLevel {
  owner = 'owner',
  read = 'read',
}

export interface SharedResources {
  resourceId: number;
  resourceType: SharedResourcesType;
  teamMembers: TeamMember[];
}
